export default "__VITE_ASSET__2acf0627__"